
const findModel = (models,id, key = 'id') => {
    const found = models.filter((cur)=>{
        return cur[key] === id;
    });

    return (found.length === 1) ? found[0] : null;
}

export {findModel}